import React, { useEffect, useState } from 'react';
import { HStack, Button, useToast, Input, FormControl } from '@chakra-ui/react';
import axios from 'axios';
import FileShareAreaController from '../../../classes/FileShareAreaController';
import useTownController from '../../../hooks/useTownController';

export default function FileUpload({
  fileShareController,
}: {
  fileShareController: FileShareAreaController;
}): JSX.Element {
  const townController = useTownController();

  const [file, setFile] = useState<File | null>(null);
  const [filename, setFilename] = useState('Choose File');
  const [uploadedFile, setUploadedFile] = useState({ fileName: '', filePath: '' });
  const [message, setMessage] = useState('');
  const backendUrl = process.env.REACT_APP_TOWNS_SERVICE_URL;
  // const [uploadPercentage, setUploadPercentage] = useState(0);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    if (!target.files) {
      return;
    }
    setFile(target.files[0]);
    setFilename(target.files[0].name);
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('picture', file ? file : '');

    try {
      const res = await axios.post(backendUrl + '/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (res.status === 200) {
        setMessage(res.data.message);
      }
      if (res.status === 500) {
        setMessage('There was a problem with the server');
      }
      const { fileName, filePath } = res.data;

      setUploadedFile({ fileName, filePath });

      fileShareController.addFile({
        uniqueID: '',
        visibleFileName: filename,
        description: 'generic description',
      });

      townController.emitFileShareAreaUpdate(fileShareController);
      setMessage('File Uploaded');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      if (err.response.status === 500) {
        setMessage('There was a problem with the server');
        console.log('There was a problem with the server');
      } else {
        // setMessage(err.response.data.msg);
        console.log(err.response.data.msg);
      }
      // setUploadPercentage(0);
    }
  };

  const toast = useToast();

  // render different alert components depending on the message received from server
  const renderAlert = () => {
    if (message === 'File is uploaded') {
      // success alert
      toast({
        title: 'File Uploaded!',
        description: "We've uploaded your file to the FileShareArea.",
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } else if (message === 'There was a problem with the server') {
      toast({
        title: 'There was an error uploading your file.',
        description: 'Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } else if (message === 'Please upload a file') {
      toast({
        title: 'Please upload a file.',
        description: 'Choose a file to upload.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
    } else {
      return null;
    }
  };

  // useeffect to render alert when message changes
  useEffect(() => {
    renderAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  return (
    <HStack spacing={10} direction='column' align='center' display='flex'>
      <FormControl>
        <form onSubmit={onSubmit}>
          <Input
            type='file'
            className='custom-file-input'
            id='customFile'
            name='picture'
            onChange={onChange}
          />

          <Button type='submit' value='Upload' display='flex'>
            Upload
            {/* <input type='submit' value='Upload' className='btn btn-primary btn-block mt-4' />{' '} */}
          </Button>
        </form>
      </FormControl>
      {uploadedFile ? (
        <div className='row mt-5'>
          <div className='col-md-6 m-auto'>
            <h3 className='text-center'>{uploadedFile.fileName}</h3>
            <img style={{ width: '100%' }} src={uploadedFile.filePath} alt='' />
          </div>
        </div>
      ) : null}
    </HStack>
  );
}
